import Cookies from "js-cookie";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { AWS_URL } from "../../Constant";

function AddProduct() {
  const initialFormData = {
    barcode: "",
    brand: "",
    model_number: "",
    // mrp: "",
    quantity: "",
    landingCost: "",
    gst: "",
    cutoffprice: "",
    productName: ""
  };
  const [formData, setFormData] = useState(initialFormData);
  const [error, setError] = useState(initialFormData);

  const ValidationForm = () => {
    let err = {};

    if (formData.barcode === "") {
      err.barcode = "Name is required";
    }
    if (formData.productName === "") {
      err.productName = "Product_Name is required";
    }
    if (formData.brand === "") {
      err.brand = "Brand is required";
    }
    if (formData.model_number === "") {
      err.model_number = "Model_number is required";
    }
    // if (formData.mrp === "") {
    //   err.mrp = "MRP is required";
    // }
    if (formData.quantity === "") {
      err.quantity = "quantity is required";
    }
    if (formData.landingCost === "") {
      err.landingCost = "LandingCost is required";
    }
    if (formData.gst === "") {
      err.gst = "GST is required";
    }
    if (formData.cutoffprice === "") {
      err.cutoffprice = "cutoffprice is required";
    }

    setError({ ...err });
    return Object.keys(err).length === 0;
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    const newValue = name === "mrp" || name === "quantity" || name === "gst" || name === "cutoffprice" || name === "landingCost"  ? parseFloat(value) : value;
    setFormData({ ...formData, [name]: newValue });
  };



  const handleSubmit = async (event) => {
    event.preventDefault();
    setFormData(initialFormData);
    let isvalid = ValidationForm();
    if (isvalid) {
      const jwtToken = Cookies.get("jwt_token");
// const url = "https://ec2-13-235-112-81.ap-south-1.compute.amazonaws.com/addData";
      const url = `${AWS_URL}/addData`
      
      const option = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
        body: JSON.stringify(formData),
      };
try {
const response = await fetch(url, option);
        await response.json();
} catch {
        //onSubmitFailure();
      }
    } else {
      alert("all data required");
    }
  };

  return (
    <>
     <div className="bg-slate-200 min-h-screen">
  {/* Dashboard button */}
  <div className="flex items-end justify-end gap-2">
    <Link to={"/dashboard"}>
      <button className="mt-2 mr-5 bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 p-2 rounded-lg w-40 text-white text-lg">
        Dashboard
      </button>
    </Link>
  </div>

  {/* Main form container */}
  <div className="flex flex-col w-full items-center justify-center px-4">
    <h1 className="text-lg font-bold mb-4 bg-gradient-to-r from-cyan-500 to-blue-500 p-2 rounded-lg text-white w-36 text-center">
      Add Products
    </h1>

    <form
      className="w-full flex flex-col items-center"
      onSubmit={handleSubmit}
    >
      {/* Row 1 */}
      <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-8/12 mb-2 mt-4">
        <div className="w-full">
          <label htmlFor="barcode">Bar Code:</label>
          <input
            type="text"
            id="barcode"
            name="barcode"
            value={formData.barcode}
            placeholder="Enter Barcode"
            onChange={handleInputChange}
            className="border-black/30 px-3 py-2 text-sm placeholder:text-gray-600 rounded-lg w-full"
          />
          <p className="text-start text-red-600 font-medium">*{error.barcode}</p>
        </div>

        <div className="w-full">
          <label htmlFor="productName">Product Name:</label>
          <input
            className="px-3 py-2 text-sm placeholder:text-gray-600 rounded-lg w-full"
            type="text"
            id="productName"
            name="productName"
            value={formData.productName}
            placeholder="Enter Product Name"
            onChange={handleInputChange}
          />
          <p className="text-start text-red-600 font-medium">*{error.productName}</p>
        </div>

        <div className="w-full">
          <label htmlFor="quantity">Quantity:</label>
          <input
            type="number"
            id="quantity"
            name="quantity"
            value={formData.quantity}
            placeholder="Enter quantity"
            onChange={handleInputChange}
            className="border-black/30 px-3 py-2 text-sm placeholder:text-gray-600 rounded-lg w-full"
          />
          <p className="text-start text-red-600 font-medium">*{error.quantity}</p>
        </div>
      </div>

      {/* Row 2 */}
      <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-8/12 mb-2 mt-3">
        <div className="w-full">
          <label htmlFor="brand">Brand:</label>
          <input
            className="px-3 py-2 text-sm placeholder:text-gray-600 rounded-lg w-full"
            type="text"
            id="brand"
            name="brand"
            value={formData.brand}
            placeholder="Enter Brand"
            onChange={handleInputChange}
          />
          <p className="text-start text-red-600 font-medium">*{error.brand}</p>
        </div>

        <div className="w-full">
          <label htmlFor="model_number">Model number:</label>
          <input
            className="px-3 py-2 text-sm placeholder:text-gray-600 rounded-lg w-full"
            type="text"
            id="model_number"
            name="model_number"
            value={formData.model_number}
            placeholder="Enter Model Number"
            onChange={handleInputChange}
          />
          <p className="text-start text-red-600 font-medium">*{error.model_number}</p>
        </div>
      </div>

      {/* Row 3 */}
      <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-8/12 mb-6 mt-3">
        <div className="w-full">
          <label htmlFor="landingCost">Landing Cost:</label>
          <input
            className="px-3 py-2 text-sm placeholder:text-gray-600 rounded-lg w-full"
            type="number"
            id="landingCost"
            name="landingCost"
            value={formData.landingCost}
            placeholder="Enter Landing Cost"
            onChange={handleInputChange}
          />
          <p className="text-start text-red-600 font-medium">*{error.landingCost}</p>
        </div>

        <div className="w-full">
          <label htmlFor="gst">GST:</label>
          <input
            className="px-3 py-2 text-sm placeholder:text-gray-600 rounded-lg w-full"
            type="number"
            id="gst"
            name="gst"
            value={formData.gst}
            placeholder="Enter GST"
            onChange={handleInputChange}
          />
          <p className="text-start text-red-600 font-medium">*{error.gst}</p>
        </div>

        <div className="w-full">
          <label htmlFor="cutoffprice">Cut off Price:</label>
          <input
            className="px-3 py-2 text-sm placeholder:text-gray-600 rounded-lg w-full"
            type="number"
            id="cutoffprice"
            name="cutoffprice"
            value={formData.cutoffprice}
            placeholder="Enter Cutoff Price"
            onChange={handleInputChange}
          />
          <p className="text-start text-red-600 font-medium">*{error.cutoffprice}</p>
        </div>
      </div>

      {/* Submit button */}
      <div className="bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 p-2 rounded-lg w-28 mt-2 text-white">
        <button type="submit" className="font-medium text-lg w-full">
          Submit
        </button>
      </div>
    </form>
  </div>
</div>

    </>
  );
}

export default AddProduct;
